<template>
  <div id="event">
    <div class="container">
      <div class="home_item_content">
        <h6>memorabilia</h6>
        <i></i>
        <h1>大事记</h1>
      </div>
      <!-- 2018 -->
      <div class="dot1">
        <p>2020</p>
        <i></i>
      </div>
      <div class="event_2020">
        <div class="event_2020_txt">
          <ul>
            <li>
              <span>3月</span> 迭代销售大神APP，加入新功能-虚拟电话。
            </li>
            <li>
              <span>6月</span> 销售大神企业入驻超百万，用户超50万。
            </li>
          </ul>
        </div>
      </div>
      <!-- 2019 -->
      <div class="dot2">
        <p>2019</p>
        <i></i>
      </div>
      <div class="event_2019">
        <div class="event_2019_txt">
          <ul>
            <li>
              <span>3月</span> 陕西远达智能科技有限公司推出了第二款产品-销售大神APP，帮助解决销售难题。
            </li>
            <li>
              <span>6月</span> 陕西远达智能科技有限公司官网上线了。
            </li>
          </ul>
        </div>
      </div>

      <!-- 2020 -->
      <div class="dot3">
        <i></i>
        <p>2018</p>
      </div>
      <div class="event_2018">
        <div class="event_2018_txt">
          <ul>
            <li>
              <span>6月</span> 陕西远达智能科技有限公司成立了。
            </li>
            <li>
              <span>7月</span> 陕西远达智能科技有限公司官网上线了。
            </li>
            <li>
              <span>9月</span> 陕西远达智能科技有限公司推出了第一款产品-万物物联APP。
            </li>
            <li>
              <span>12月</span>万物物联APP的客户破百，用户超10万。
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
#event {
  background: url("../../assets/images/event_1.png") no-repeat;
  background-position: center;
  height: 1299px;
  min-width: 1200px;
  .container {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .home_item_content {
      position: absolute;
      top: 120px;
      right: 100px;
      h6 {
        font-size: 14px;
        line-height: 20px;
        text-transform: uppercase;
      }
      i {
        display: block;
        height: 4px;
        width: 40px;
        background: rgba(38, 172, 255, 1);
        margin: 8px 0;
      }
      h1 {
        font-size: 36px;
        line-height: 50px;
        font-weight: 500;
      }
      .content {
        margin-top: 40px;
        text-indent: 2em;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
}
.container {
  .dot1 {
    position: absolute;
    left: 70px;
    top: 298px;

    p {
      text-indent: 2em;
      font-size: 20px;
      line-height: 28px;
    }
    i {
      display: block;
      width: 20px;
      height: 20px;
      background: rgba(38, 172, 255, 1);
      border-radius: 50%;
    }
  }
  .event_2020 {
    display: inline-block;
    position: absolute;
    top: 272px;
    left: 200px;

    .event_2020_txt {
      width: 496px;

      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 10px 20px rgba(0, 9, 94, 0.11);
      border-radius: 5px;
      padding: 30px;
      li {
        font-size: 14px;
        line-height: 30px;
      }
      span {
        display: inline-block;
        margin-right: 20px;
        color: rgba(38, 172, 255, 1);
      }
    }
  }
}
.container {
  position: relative;
  .dot2 {
    position: absolute;
    left: 471px;
    top: 530px;

    p {
      text-indent: 2em;
      font-size: 20px;
      line-height: 28px;
    }
    i {
      display: block;
      width: 20px;
      height: 20px;
      background: rgba(38, 172, 255, 1);
      border-radius: 50%;
    }
  }
  .event_2019 {
    display: inline-block;
    position: absolute;
    top: 524px;
    right: -10px;

    .event_2019_txt {
      height: 116px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 10px 20px rgba(0, 9, 94, 0.11);
      border-radius: 5px;
      padding: 30px;
      li {
        font-size: 14px;
        line-height: 30px;
      }
      span {
        display: inline-block;
        margin-right: 20px;
        color: rgba(38, 172, 255, 1);
      }
    }
  }
}
.container {
  position: relative;
  .dot3 {
    position: absolute;
    right: 532px;
    top: 720px;
    p {
      text-indent: -3em;
      font-size: 20px;
      line-height: 28px;
    }
    i {
      display: block;
      width: 20px;
      height: 20px;
      background: rgba(38, 172, 255, 1);
      border-radius: 50%;
    }
  }
  .event_2018 {
    display: inline-block;
    position: absolute;
    top: 750px;
    left: 75px;

    .event_2018_txt {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 10px 20px rgba(0, 9, 94, 0.11);
      border-radius: 5px;
      padding: 30px;
      li {
        font-size: 14px;
        line-height: 30px;
      }
      span {
        display: inline-block;
        margin-right: 20px;
        color: rgba(38, 172, 255, 1);
      }
    }
  }
}
</style>